import { APP_CONFIG } from '../configs/config';

export const patentService = {
  search: async ({ asin, query, title, description, topK = 500, useAiRewrite = false }) => {
    let requestBody = {
      top_k: topK,
      use_ai_rewrite: useAiRewrite,
    };

    if (asin) {
      requestBody.asin = asin;
    } else if (query) {
      requestBody.query = query;
      if (title) { 
        requestBody.title_enhance = title;
      }
    } else if (title || description) {
      requestBody.query = `${title || ''} ${description || ''}`.trim();
    }

    const response = await fetch(`${APP_CONFIG.API_BASE_URL}/patent-infringement/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to search patents');
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.message || 'Search failed');
    }

    return data;
  },

  getSearchResults: async (resultId) => {
    const response = await fetch(`${APP_CONFIG.API_BASE_URL}/patent-infringement/result/${resultId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch search results');
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.message || 'Failed to fetch results');
    }

    return data;
  },

  getPatentImage: async (patentId, imageId = 0, maxWidth = 203, maxHeight = 203) => {
    const apiUrl = APP_CONFIG.API_PATENTINFO_URL || APP_CONFIG.API_BASE_URL;
    const cleanPatentId = patentId.split('-')[0];
    const url = new URL(`${apiUrl}/get_patent_image/${cleanPatentId}`);
    url.searchParams.append('image_id', imageId);
    url.searchParams.append('max_width', maxWidth);
    url.searchParams.append('max_height', maxHeight);

    const response = await fetch(url.toString(), {
      method: 'GET',
    });

    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error('Failed to fetch patent image');
    }

    const imageBlob = await response.blob();
    return URL.createObjectURL(imageBlob);
  },

  getPatentDetail: async (patentId) => {
    const response = await fetch(`${APP_CONFIG.API_BASE_URL}/patent-infringement/patent-detail/${patentId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch patent detail');
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.message || 'Failed to fetch patent detail');
    }

    return data;
  },

  startReviewAnalysis: async (asin) => {
    const response = await fetch(`${APP_CONFIG.API_BASE_URL}/patent-review/analyze`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ asin }),
    });

    if (!response.ok) {
      throw new Error('Failed to start review analysis');
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.message || 'Failed to start analysis');
    }

    return data;
  },

  getReviewResult: async (resultId) => {
    const response = await fetch(`${APP_CONFIG.API_BASE_URL}/patent-review/result/${resultId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch review result');
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.message || 'Failed to fetch result');
    }

    return data;
  },

  getProductDataByAsin: async (asin) => {
    const response = await fetch(`${APP_CONFIG.API_BASE_URL}/patent-review/product-data/${asin}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error('Failed to fetch product data');
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.message || 'Failed to fetch product data');
    }

    return data;
  },
};


